import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";
import { STATUS } from "@/constant/statusConstants";

const CompetitionSchema = (localeCodes, isEdit = false) => Yup.object().shape({
  sport_id: Yup
    .string()
    .label("Sport ID")
    .required(),
  code: Yup
    .string()
    .label("ID")
    .required()
    .max(50),
  status: Yup
    .string()
    .label("Status")
    .required()
    .oneOf(Object.values(STATUS)),
  localizations: createLocalizationsSchema(localeCodes),
  icon: Yup.mixed().label("Icon").when([], {
    is: () => isEdit,
    then: (schema) => schema.nullable(),
    otherwise: (schema) => schema.required(),
  }),
});

export default CompetitionSchema;
